import { BasePresenter } from "core/presenter";
import { RuntimeRepository, UserRepository } from "core/repository";

class AppPresenter extends BasePresenter {
  static sRenewTokenInterval = 180 * 60 * 1000; // 180m

  initialState() {
    return {
      user: {},
      supportVisible: false,
      forceHide: false
    };
  }

  async onStart() {
    this.userContext = {};

    await Promise.all([this.getCurrentUserInfo()]);
    this.subscribeToSupportChanges();
    this.subscribeToUserChanges();
    this.setupTokenRenewal();

    this.router.transitionService.onStart({}, async transition => {
      if (!this._userCanAccess(transition)) {
        return this.router.stateService.target("app.forbidden");
      }
    });

    this.router.transitionService.onSuccess({}, transition => {
      if (!this._userCanAccess(transition)) {
        this.navigateTo("app.forbidden");
      }
    });

    this.router.transitionService.onEnter({}, transition => {
      this.viewModel.forceHide = ["app.signup", "app.login"].includes(
        transition.to().name
      );
    });
  }

  _userCanAccess(transition) {
    const data = transition.to().data;

    if (data && data.authorization) {
      if (!data.authorization(this.userContext)) {
        return false;
      }
    }

    return true;
  }

  async getCurrentUserInfo() {
    const currentUser = await this.mRuntime.get(
      RuntimeRepository.props.currentUser
    );
    this._handleCurrentUserChange(currentUser);
  }

  subscribeToUserChanges() {
    this.subscribeTo(RuntimeRepository.props.currentUser, currentUser =>
      this._handleCurrentUserChange(currentUser)
    );
  }

  subscribeToSupportChanges() {
    this.subscribeTo(RuntimeRepository.props.supportVisible, supportVisible =>
      this._handleSupportChange(supportVisible)
    );
  }

  setupTokenRenewal() {
    this.mTokenRenewalInterval = setInterval(
      () => UserRepository.getLoggedInUser(),
      AppPresenter.sRenewTokenInterval
    );
    this.subscribeTo(RuntimeRepository.props.logoutByInactivity, () =>
      this.logoutByInactivity()
    );
  }

  logoutByInactivity() {
    this.navigateTo("app.login");
    this.sendNotification({
      type: "error",
      title: "Oops...",
      content:
        "Parece que você ficou inativo por tempo demais. Por favor, acesse novamente."
    });
  }

  onEnd() {
    clearInterval(this.mTokenRenewalInterval);
    super.onEnd();
  }

  onHideSupport() {
    this.mRuntime.fire(RuntimeRepository.props.supportVisible, false);
  }

  _handleSupportChange(supportVisible) {
    this.viewModel.supportVisible = supportVisible;
  }

  _handleCurrentUserChange(currentUser) {
    if (currentUser) {
      this.userContext = { user: currentUser, company: currentUser.company };

      let companyData = {};

      if (currentUser.company) {
        companyData = {
          phone: currentUser.company.phone,
          company_name: currentUser.company.name,
          company: {
            company_id: currentUser.company_uuid,
            name: currentUser.company.name,
            phone: currentUser.company.phone
          }
        };
      }

      this.viewModel.user = {
        user_id: currentUser.uuid,
        email: currentUser.username,
        name: currentUser.name,
        ...companyData
      };
    } else {
      this.userContext = { user: {}, company: {} };
      this.viewModel.user = {};
    }
  }
}

export default AppPresenter;



// WEBPACK FOOTER //
// ./src/components/app/app.presenter.js